import { Tooltip } from '@aleph/shared-components';

interface IProps {
	tooltipText: string
	icon: React.ReactNode
}

function EntityEditIconNotAllowed({ tooltipText, icon }: IProps) {
	return (
		<Tooltip
			className="!z-above-modal"
			size="medium"
			singleLine
			content={
				<p className="text-center">
					{tooltipText}
				</p>
			}
		>
			<div className="text-gray-600 cursor-not-allowed">
				{icon}
			</div>
		</Tooltip>
	);
}

export default EntityEditIconNotAllowed;
